// reportingApi.ts
// Service pour les endpoints de reporting agrégé (non CRUD).

import apiFetch from 'common/services/apiFetch';
import { getApiBaseUrl } from 'common/services/apiBaseUrl';

const API_URL = getApiBaseUrl() + '/v2';

// --- Types ---

export interface ReportingByServiceRow {
	serviceId: number | null;
	serviceLabel: string | null;
	totalHours: number;
	billableHours: number;
	nonBillableHours: number;
	totalExclTax: number;
}

export interface ReportingByServiceTotals {
	totalHours: number;
	billableHours: number;
	nonBillableHours: number;
	totalExclTax: number;
}

export interface ReportingByServiceResult {
	rows: ReportingByServiceRow[];
	totals: ReportingByServiceTotals;
}

// --- Types : par facture client ---

export interface ReportingByCustomerInvoiceRow {
	id: number;
	referenceNumber: string;
	invoiceDate: string;
	dueDate: string | null;
	label: string;
	projectReference: string | null;
	// Ventilation par catégorie de prestation (activités)
	forfaitMensuel: number;
	akOfc: number;
	forfait: number;
	halfForfait: number;
	salle: number;
	visite: number;
	sequenceTerrain: number;
	locationEprouvette: number;
	autresServices: number;
	// Éléments logistiques
	conso: number;
	// Colonnes de contrôle
	caHtFac: number;
	totalHt: number;
}

export interface ReportingByCustomerInvoiceTotals {
	forfaitMensuel: number;
	akOfc: number;
	forfait: number;
	halfForfait: number;
	salle: number;
	visite: number;
	sequenceTerrain: number;
	locationEprouvette: number;
	autresServices: number;
	conso: number;
	caHtFac: number;
	totalHt: number;
}

export interface ReportingByCustomerInvoiceResult {
	rows: ReportingByCustomerInvoiceRow[];
	totals: ReportingByCustomerInvoiceTotals;
}

// --- API ---

export const reportingApi = {
	/** Agrégat des heures et CA HT par service sur une période donnée */
	byService: async (
		token: string,
		params?: { from?: string; to?: string }
	): Promise<ReportingByServiceResult> => {
		const query = new URLSearchParams();
		if (params?.from) query.set('from', params.from);
		if (params?.to) query.set('to', params.to);

		const url = `${API_URL}/reporting/by-service${query.toString() ? '?' + query.toString() : ''}`;

		const res = await apiFetch(url, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
		});

		return res.json();
	},

	/** CA HT ventilé par catégorie de prestation, pour chaque facture client sur une période */
	byCustomerInvoice: async (
		token: string,
		params?: { from?: string; to?: string }
	): Promise<ReportingByCustomerInvoiceResult> => {
		const query = new URLSearchParams();
		if (params?.from) query.set('from', params.from);
		if (params?.to) query.set('to', params.to);

		const url = `${API_URL}/reporting/by-customer-invoice${query.toString() ? '?' + query.toString() : ''}`;

		const res = await apiFetch(url, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
		});

		return res.json();
	},
};
